export const APP_CHROME_PREFIXES = [
  '/trade',
  '/portfolio',
  '/public-pools',
  '/staking',
  '/referrals',
  '/sub-accounts',
  '/funding-market-risk-parameters',
]

export function usesAppChrome(pathname) {
  return APP_CHROME_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}

export function usesFillHeader(pathname) {
  return usesAppChrome(pathname) && !pathname.startsWith('/trade')
}
